import React from 'react';
import placeholder from '../../assets/images/icons/Profile.svg';
import edit from '../../assets/images/icons/Edit.svg';

/**
 * Item for ContactList component
 * @param {Object} [props]
 * @param {string} [props.image] - Image url
 * @param {Object} [props.contactPerson] - Contact person
 * @param {Function} [props.onEditClick] - Edit contact callback
 * @param {boolen} [props.editDisabled] - Edit icon button disabled
 * @param {boolen} [props.selected] - Selected style
 * @component
 */
export default ({
  image = placeholder,
  contactPerson = {},
  onEditClick = () => {},
  editDisabled = false,
  selected = false,
  ...restProps
}) => (
  <div className={`Item${selected ? ' selected' : ''}`} {...restProps} onClick={!editDisabled ? onEditClick : () => {}}>
    <img src={image} alt="Profile" className="Item-profile" />

    <div className="Item-info">
      <h3 className="Item-info-name">{contactPerson.last_name} {contactPerson.first_name}</h3>

      <h4 className="Item-info-phone">{contactPerson.phone}</h4>
    </div>

    <img
      src={edit}
      alt="Edit"
      className={editDisabled ? 'Item-edit disabled' : 'Item-edit'}
    />
  </div>
);
